import { notification } from "antd";
import React, { useState } from "react";
import apiService from "../../services/api";
import Body from "./Body";
import StepCustomHeader from "./Header";
import { StyledBox } from "./styled";

const Stepper = ({ data, setData }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [historyStep, setHistoryStep] = useState(0);

  const createLead = async () => {
    try {
      setLoading(true);
      await apiService({
        route: "createLeads",
        payload: { ...data, categorie: JSON.stringify(data.categorie) },
      });
      setLoading(false);
      notification.success({ message: "Votre demande a bien été envoyée" });
      setCurrentStep((last) => last + 1);
    } catch (error) {
      console.log("error:", error.response.data.errors.message);
      setLoading(false);
      notification.error({
        message: `${error.response.data.errors.message}`,
      });
    }
  };
  const onChange = () => {
    if (currentStep === 3) {
      createLead();
    } else {
      setCurrentStep((last) => last + 1);
      setHistoryStep((last) => last + 1);
    }
  };

  const steps = [
    {
      title: "SERVICE",
    },
    {
      title: "JOUR",
    },
    {
      title: "LIEN",
    },
    {
      title: "DEVIS",
    },
    {
      title: "⭐️⭐️⭐️⭐️⭐️ 4,7/5 sur Google",
      final: true,
    },
  ];
  return (
    <StyledBox>
      <StepCustomHeader
        setCurrent={setCurrentStep}
        items={steps}
        current={currentStep}
        historyStep={historyStep}
      />
      <Body
        loading={loading}
        currentStep={currentStep}
        data={data}
        setData={setData}
        Next={onChange}
      />
    </StyledBox>
  );
};

export default Stepper;
